import { h } from 'preact'
import { signal } from '@preact/signals'
import { tagParser, safeHtml } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'

export const reassuranceEquipementState = signal('')

export const ReassuranceEquipement = ({ cacheKey, items }) => {
   if (reassuranceEquipementState.value !== '' && reassuranceEquipementState.value['card3'] !== undefined) {
      items.push(reassuranceEquipementState.value['card3'].items[0])
   }

   return (
      <div class="container-fluid">
         <div id="zone_reassurance_mobile" data-testid="bande-reassurance-equipement" class="row mb-2 mb-md-4 reassurance-equipement" data-cache-key={cacheKey}>
            <h2 class="sr-only">Pourquoi acheter chez Orange</h2>
            {items.map((data, index) => (
               <Card {...data} index={index} />
            ))}
         </div>
      </div>
   )
}

const Card = ({ title, description, CTA, index }) => {
   return (
      <div
         class="col-12 col-md-4 mt-2 mt-md-0 lien-composite-before"
         data-testid={`reassurance-equipement${index}`}
         {...attributesAnalytics(CTA.analytics)}
      >
         <div class="item">
            <h3 class="title mb-0" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }}></h3>
            <p class="mb-0 mb-md-1" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(description)) }}></p>
            <a href={CTA.URL} class="cta mt-auto mw-100 o-link-arrow">
               <strong class="mw-100">{CTA.label}</strong>
            </a>
         </div>
      </div>
   )
}
